import React from "react";
import { observable, action } from "mobx";
import * as Api from "api";
import * as AppGroup from "api/developers/AppGroup";

export class Store {
  @observable.ref
  public loading = false;

  @observable.ref
  public appGroups: AppGroup.IndexResponse[] = [];

  @action.bound
  public async fetchAppGroups(developerId: number) {
    this.loading = true;

    const response = await AppGroup.Api.index(developerId);

    if (response?.status === Api.Status.OK) {
      this.appGroups = response.data;
    }

    this.loading = false;
  }
}

const Context = React.createContext<Store | null>(null);

export const StoreProvider: React.FC<{ value?: Store }> = ({
  children,
  value,
}) => {
  const store = React.useMemo(() => (value ? value : new Store()), [value]);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useStore = () => {
  const store = React.useContext(Context);
  if (!store) {
    throw new Error("useStore must be used within a StoreProvider.");
  }
  return store;
};
